<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Groups</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="25"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="name"
            direction="ASC"
            delete-label="name"
            :actions="actions"
            :permissions="true"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../../mixins/DataTableSetup';

    export default {
        name: "Groups",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'groups',
                numberOfFilters: 2,
                pageActions: {},
                fields: [
                    {
                        name: 'Name',
                        column: 'name',
                        route: '/configuration/groups/{id}/edit',
                        linked: true,
                        sortCol: 'name'
                    },
                    {
                        name: 'Description',
                        column: 'description',
                    },
                    {
                        name: 'Type',
                        column: 'type.name',
                    },
                    {
                        name: 'Active',
                        column: 'active',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: 'groups.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: 'groups.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            // Types Filter
            const typesFilter = {
                label: 'Type',
                name: 'type',
                type: 'select',
                options: this.$store.getters.groupTypes.map(function (type) {
                    return { label: type.name, value: type.id };
                }),
                width: 'w-1/4',
                value: this.groupTypeValue,
                placeholder: 'Select Type...'
            };

            if (this.$store.getters.groupTypes.length === 0){
                this.$store.dispatch('GET_GROUP_TYPES').then(() => {
                    typesFilter.options = this.$store.getters.groupTypes.map(function (type) {
                        return { label: type.name, value: type.id };
                    });
                    typesFilter.value = this.groupTypeValue;
                    this.filters.push(typesFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(typesFilter);
            }

            this.pageActions = {
                buttons: [
                    {
                        label: 'New Group',
                        icon: 'plus',
                        type: 'router-link',
                        link: '/configuration/groups/create',
                        iconClass: 'text-green-600',
                        display: this.$store.getters.permissions.indexOf('groups.create') !== -1
                    }
                ],
                additional: []
            }
        },
        computed: {
            groupTypeValue() {
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.groups.type)) {
                    return filters.groups.type;
                } else {
                    return null;
                }
            },
        }
    }
</script>

<style scoped>

</style>
